import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { GENERAL } from 'self-service-api/constants/UpgradeProducts';
import { UPGRADE_PAGE } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import { APP } from '../../constants/tracking/App';
import { MERCH_CARD, SCREENS } from '../../constants/tracking/Locations';
import PurchaseMotionButtonWrapper from '../common/purchaseMotions/PurchaseMotionButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTableCTA = ({
  ctaStyles,
  currencyCode,
  handlePurchaseMotionButtonClick = () => {},
  productConfigurations,
  purchaseMotions,
  upgradePointApiName,
  trackingSource,
  upgradeKey,
  feature
}) => {
  const queryParams = getQueryParams();
  const upgradeSource = queryParams.upgradeSource;
  const upgradeData = {
    apiName: upgradePointApiName,
    app: APP,
    screen: SCREENS.UPGRADE_PAGE,
    uniqueId: `${SCREENS.UPGRADE_PAGE}-${ApiNameToUpgradeProductMap[upgradePointApiName]}-feature-table`,
    upgradeProduct: ApiNameToUpgradeProductMap[upgradePointApiName] || GENERAL,
    upgradeKey,
    upgradeSource,
    feature
  };
  if (!purchaseMotions || purchaseMotions.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(PurchaseMotionButtonWrapper, {
    currencyCode: currencyCode,
    level: 1,
    onClick: handlePurchaseMotionButtonClick,
    productConfigurations: productConfigurations,
    location: UPGRADE_PAGE,
    purchaseMotions: [purchaseMotions[0]],
    style: ctaStyles,
    trackingSource: trackingSource || MERCH_CARD,
    upgradeData: upgradeData,
    use: "primary"
  });
};
export default FeatureTableCTA;